import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import normalRoom from "./components/normal-room";
import absorbingCeilingPanels from "./components/absorbing-ceiling-panels";
import absorbingWallPanels from "./components/absorbing-wall-panels";
import allAbsorbingPanels from "./components/all-absorbing-panels";

const principle: Slide = {
  description:
    "In this typical scene a teacher (red dot) is speaking in front of the students (plane area). For the optimisation we will evaluate the Clarity Index C50 under different modifications of the room. Please select the options and compare the results.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Normal room" },
            { name: "Absorbing ceiling panels" },
            { name: "Absorbing wall panels" },
            { name: "All absorbing panels" },
          ],
        },
      ],
      extraContent: [[], [], [], []],
      components: [normalRoom, absorbingCeilingPanels, absorbingWallPanels, allAbsorbingPanels],
    },
  },
};

export default principle;
